import useWidth from '@/hooks/useWidth'
import { emailOuCPFRegex } from '@/utils/constants'
import {
  Button,
  Col,
  FieldInput,
  Form,
  Label,
  PrevLogo,
  Row,
  Typography,
  useErrorHandlingContext,
  usePrevTheme,
} from '@prev/ui-kit'
import React, { useContext, useEffect, useState } from 'react'
import { LoginContext } from '../../contexts/LoginContext'
import { ForgotPasswordModal } from '../forgotPassword/ForgotPasswordModal'
import { getSlug } from '@/services/oauth'
import { getSlugDaURL } from '@/utils/utils'

const { Text } = Typography

export interface FormProps {
  username: string
  password: string
}

const SignIn = (): JSX.Element => {
  const { clearLogin, handleLogin, checkedSlug, setCheckedSlug } = useContext(LoginContext)
  const { theme } = usePrevTheme()
  const [isLoading, setIsLoading] = useState(false)
  const [isRecoveryOpen, setIsRecoveryOpen] = useState(false)
  const width = useWidth()
  const { setGlobalError } = useErrorHandlingContext()
  const slug = getSlugDaURL()

  const validateSlug = async () => {
    try {
      await getSlug(slug as string)
      setCheckedSlug(true)
    } catch (err) {
      setGlobalError(err)
    }
  }

  useEffect(() => {
    if (!checkedSlug && slug) {
      validateSlug()
    }
  }, [checkedSlug])

  return (
    <Col
      span={10}
      xxl={10}
      xl={10}
      lg={10}
      md={10}
      sm={24}
      xs={24}
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: '100%',
        padding: `0 ${width < 1280 ? '20px' : '95px'}`,
      }}
    >
      <Form
        data-testid="form-office-form"
        name="officeForm"
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
        layout="vertical"
        onFinish={async (formData) => {
          setIsLoading(true)
          await handleLogin(formData)
          setIsLoading(false)
        }}
      >
        <Row style={{ marginBottom: '29px' }}>
          <PrevLogo />
        </Row>
        <Text style={{ marginBottom: '16px' }} size="h5" emphasis data-testid="boas-vindas-slug-escritorio">
          Seja bem-vindo: {slug}
        </Text>
        <Label style={{ marginBottom: '16px' }}>
          Email ou CPF <span style={{ color: theme.color.text.danger }}>*</span>
          <Form.Item
            name="username"
            style={{ margin: 0 }}
            validateDebounce={500}
            required={false}
            rules={[
              {
                required: true,
                message: 'Campo obrigatório',
              },
              {
                message: 'Email ou CPF inválido, verifique o formato',
                pattern: emailOuCPFRegex,
              },
            ]}
          >
            <FieldInput
              disabled={isLoading}
              style={{ width: '340px' }}
              data-testid="inpt-email-cpf"
              placeholder="Digite seu email ou CPF"
            />
          </Form.Item>
        </Label>
        <Label>
          Senha <span style={{ color: theme.color.text.danger }}>*</span>
          <Form.Item
            name="password"
            style={{ margin: 0 }}
            required={false}
            rules={[
              {
                required: true,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <FieldInput.Password
              disabled={isLoading}
              style={{ width: '340px' }}
              data-testid="inpt-senha"
              placeholder="Digite sua senha"
            />
          </Form.Item>
        </Label>
        <Row>
          <Button
            type="link"
            data-testid="btn-esqueceu-senha"
            disabled={isLoading}
            onClick={() => {
              setIsRecoveryOpen(!isRecoveryOpen)
            }}
            style={{ cursor: 'pointer', paddingLeft: 0 }}
          >
            Esqueceu sua senha ?
          </Button>
        </Row>
        <Button
          size="large"
          data-testid="btn-avancar-login"
          htmlType="submit"
          type="primary"
          style={{ marginTop: '40px', width: '340px' }}
          loading={isLoading}
        >
          <Text color="white" style={{ fontSize: '20px' }}>
            Avançar
          </Text>
        </Button>
        <Row style={{ gap: '1px', alignItems: 'center' }}>
          <Text style={{ fontSize: '16px' }}>Escritório errado?</Text>
          <Button
            type="link"
            disabled={isLoading}
            data-testid="btn-login-outro-escritorio"
            style={{ cursor: 'pointer', paddingLeft: 0 }}
            onClick={clearLogin}
          >
            Faça login com outro escritório
          </Button>
        </Row>
      </Form>
      <ForgotPasswordModal isOpenRecovery={isRecoveryOpen} setIsOpenRecovery={setIsRecoveryOpen} slug={slug} />
    </Col>
  )
}

export default SignIn
